import LegalNavbar from '../../components/feature/LegalNavbar';
import LegalFooter from '../../components/feature/LegalFooter';

const SECTIONS = [
  {
    title: '1. Datos identificativos del titular',
    content: (
      <div className="space-y-2 text-gray-600 text-sm leading-relaxed">
        <p>En cumplimiento con el artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa de los siguientes datos identificativos del titular del sitio web:</p>
        <ul className="mt-4 space-y-2">
          <li className="flex gap-2"><strong className="text-[#1B3A5C] min-w-[130px]">Titular:</strong><span>Jaime Garcia Larrache Olalquia</span></li>
          <li className="flex gap-2"><strong className="text-[#1B3A5C] min-w-[130px]">N.I.F.:</strong><span>50829100C</span></li>
          <li className="flex gap-2"><strong className="text-[#1B3A5C] min-w-[130px]">Domicilio:</strong><span>C/ Zurbano 96, 6º Derecha, 28003 Madrid</span></li>
          <li className="flex gap-2"><strong className="text-[#1B3A5C] min-w-[130px]">Correo electrónico:</strong><span><a href="mailto:jlarrache@mediatioglobal.com" className="text-[#3D9E8C] hover:underline">jlarrache@mediatioglobal.com</a></span></li>
          <li className="flex gap-2"><strong className="text-[#1B3A5C] min-w-[130px]">Teléfono:</strong><span><a href="tel:+34696342047" className="text-[#3D9E8C] hover:underline">(+34) 696 342 047</a></span></li>
          <li className="flex gap-2"><strong className="text-[#1B3A5C] min-w-[130px]">Sitio web:</strong><span><a href="https://www.mediatioglobal.com" rel="nofollow" className="text-[#3D9E8C] hover:underline">www.mediatioglobal.com</a></span></li>
        </ul>
      </div>
    ),
  },
  {
    title: '2. Objeto y ámbito de aplicación',
    content: (
      <p className="text-gray-600 text-sm leading-relaxed">
        El presente Aviso Legal regula el acceso y uso del sitio web <strong>www.mediatioglobal.com</strong> (en adelante, "el Sitio Web"), puesto a disposición del público por el titular indicado anteriormente. El acceso y la navegación por el Sitio Web implica la aceptación expresa e íntegra de todas las condiciones recogidas en el presente Aviso Legal. Si el usuario no está de acuerdo con las presentes condiciones, deberá abstenerse de utilizar el Sitio Web.
      </p>
    ),
  },
  {
    title: '3. Propiedad intelectual e industrial',
    content: (
      <div className="space-y-3 text-gray-600 text-sm leading-relaxed">
        <p>Todos los contenidos del Sitio Web, incluyendo, sin carácter limitativo, textos, gráficos, imágenes, diseño, marcas, logotipos, nombres comerciales, datos y software son propiedad del titular o de terceros que han autorizado su uso, y están protegidos por las leyes nacionales e internacionales de propiedad intelectual e industrial.</p>
        <p>El usuario se compromete a respetar los derechos de propiedad intelectual e industrial titularidad del titular o de terceros. Queda expresamente prohibida la reproducción, distribución, comunicación pública, transformación o cualquier otra forma de explotación, total o parcial, de los contenidos del Sitio Web sin la autorización expresa y por escrito del titular.</p>
      </div>
    ),
  },
  {
    title: '4. Condiciones de acceso y uso',
    content: (
      <div className="space-y-3 text-gray-600 text-sm leading-relaxed">
        <p>El acceso al Sitio Web es libre y gratuito. El uso del Sitio Web se realizará bajo la exclusiva responsabilidad del usuario, quien se compromete a hacer un uso adecuado de los contenidos y servicios que el titular ofrece, y no emplearlos para:</p>
        <ul className="list-disc pl-5 space-y-1 mt-2">
          <li>Incurrir en actividades ilícitas, ilegales o contrarias a la buena fe y al orden público.</li>
          <li>Difundir contenidos o propaganda de carácter racista, xenófobo, pornográfico o que atente contra los derechos humanos.</li>
          <li>Introducir o difundir virus informáticos o cualesquiera otros sistemas físicos o lógicos que sean susceptibles de provocar daños en los sistemas informáticos del titular o de terceros.</li>
          <li>Vulnerar los derechos de propiedad intelectual o industrial, así como violar la confidencialidad de la información del titular o de terceros.</li>
        </ul>
      </div>
    ),
  },
  {
    title: '5. Exclusión de garantías y responsabilidad',
    content: (
      <div className="space-y-3 text-gray-600 text-sm leading-relaxed">
        <p>El titular no garantiza la inexistencia de interrupciones o errores en el acceso al Sitio Web ni en su contenido. El titular tampoco se responsabiliza de los daños y perjuicios que puedan derivarse de interferencias, interrupciones, fallos, omisiones, averías telefónicas, retrasos, bloqueos o desconexiones en el funcionamiento del sistema electrónico.</p>
        <p>El titular se reserva el derecho a suspender, modificar, restringir o interrumpir el acceso al Sitio Web, de forma temporal o definitiva, sin previo aviso.</p>
      </div>
    ),
  },
  {
    title: '6. Legislación aplicable y jurisdicción',
    content: (
      <p className="text-gray-600 text-sm leading-relaxed">
        Las presentes condiciones se rigen por la legislación española. Para la resolución de cualquier controversia derivada del acceso o uso del Sitio Web, el titular y el usuario se someten, con renuncia expresa a cualquier otro fuero que pudiera corresponderles, a los Juzgados y Tribunales de Madrid, salvo que la normativa aplicable establezca un fuero imperativo diferente.
      </p>
    ),
  },
  {
    title: '7. Modificación del aviso legal',
    content: (
      <p className="text-gray-600 text-sm leading-relaxed">
        El titular se reserva el derecho a modificar el presente Aviso Legal en cualquier momento. Dichas modificaciones serán publicadas en el Sitio Web y entrarán en vigor desde su publicación. Se recomienda al usuario revisar periódicamente el presente Aviso Legal.
      </p>
    ),
  },
];

export default function AvisoLegal() {
  return (
    <div className="min-h-screen bg-[#F4F7FA] flex flex-col">
      <LegalNavbar />
      <main className="flex-1">
        {/* Hero */}
        <section className="bg-[#1B3A5C] py-14">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-[#3D9E8C] mb-3">Información Legal</span>
            <h1 className="font-playfair text-3xl md:text-4xl font-bold text-white mb-3">Aviso Legal</h1>
            <p className="text-white/60 text-sm">Última actualización: 23 de marzo de 2026</p>
          </div>
        </section>

        {/* Content */}
        <section className="py-14">
          <div className="max-w-4xl mx-auto px-6">
            <div className="bg-white rounded-lg overflow-hidden">
              {SECTIONS.map((section, i) => (
                <div key={i} className={`px-8 py-7 ${i !== SECTIONS.length - 1 ? 'border-b border-gray-100' : ''}`}>
                  <h4 className="font-semibold text-[#1B3A5C] text-base mb-4">
                    <a id={`aviso-seccion-${i + 1}`} href={`#aviso-seccion-${i + 1}`}>{section.title}</a>
                  </h4>
                  {section.content}
                </div>
              ))}
            </div>

            {/* Contact box */}
            <div className="mt-8 bg-[#1B3A5C]/5 border border-[#1B3A5C]/10 rounded-lg p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#3D9E8C]/15 flex-shrink-0">
                <i className="ri-mail-line text-[#3D9E8C] text-lg" />
              </div>
              <div>
                <p className="text-sm font-semibold text-[#1B3A5C]">¿Tienes alguna pregunta sobre este aviso legal?</p>
                <p className="text-xs text-gray-500 mt-0.5">Puedes contactarnos en <a href="mailto:jlarrache@mediatioglobal.com" className="text-[#3D9E8C] hover:underline">jlarrache@mediatioglobal.com</a> o llamar al <a href="tel:+34696342047" className="text-[#3D9E8C] hover:underline">(+34) 696 342 047</a></p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <LegalFooter />
    </div>
  );
}
